import './App.scss';

import React, { Component } from 'react';
import { detect } from 'detect-browser';
import Logger from '@KrashidBuilt/common/utils/logger';

import { SpotlightProvider, UserContext } from './ctx';
import Router from './routes/Router';
import * as credentials from './api/credentials';

const logger = new Logger('App');

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: null,
            browser: detect(),
        };


        window.app = {
            credentials,
        };
    }

    setUser = (user, callback) => {
        this.setState({ user }, callback);
    }

    render() {
        logger.extra({ _: this });
        const { user } = this.state;

        return (
            <UserContext.Provider value={{ user, setUser: this.setUser }}>
                <SpotlightProvider>
                    <div className={'App'}>
                        <Router />
                    </div>
                </SpotlightProvider>
            </UserContext.Provider>
        );
    }
}

App.defaultProps = {};

App.propTypes = {
};

export default App;
